"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var i0 = require("./contact-us.component.scss.shim.ngstyle");
var i1 = require("@angular/core");
var i2 = require("./contact-us.component");
var styles_ContactUsComponent = [i0.styles];
var RenderType_ContactUsComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ContactUsComponent, data: {} });
exports.RenderType_ContactUsComponent = RenderType_ContactUsComponent;
function View_ContactUsComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "div", [["class", "container pt-2 pb-2"]], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, [" CONTACT US "]))], null, null); }
exports.View_ContactUsComponent_0 = View_ContactUsComponent_0;
function View_ContactUsComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-contact-us", [], null, null, null, View_ContactUsComponent_0, RenderType_ContactUsComponent)), i1.ɵdid(1, 114688, null, 0, i2.ContactUsComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
exports.View_ContactUsComponent_Host_0 = View_ContactUsComponent_Host_0;
var ContactUsComponentNgFactory = i1.ɵccf("app-contact-us", i2.ContactUsComponent, View_ContactUsComponent_Host_0, {}, {}, []);
exports.ContactUsComponentNgFactory = ContactUsComponentNgFactory;
